module.exports = __webpack_public_path__ + "img/4452345.a2f31446.png";